import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import logo from "../img/logo.png";
// import { X } from "react-feather";
import whatsapp from "../img/whatsapp.png";
import {
  checkSignup,
  createNewUser,
  login,
  registration,
  loginHC,
  setHCIDAction,
  SaveCandidateId,
} from "store/Auth";
import PinInput from "react-pin-input";
import Session from "react-session-api";
import App from "CheckValidateRoute";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Check, X } from "react-feather";
import PasswordChecklist from "react-password-checklist";
class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      mobileNumber: "",
      otp: "",
      password: "",
      Repassword: "",
      Name: "",
      isSideBarVisiable: false,
      isUserExist: 0,
      dobVerify: new Date("1996-07-03T00:00:00"),
      emailVerify: "",
      isKeepSignIN: false,
      termsCondition: false,
      isValid: false,
      whatsappConsent: false,
    };
  }
  onClear = () => {
    this.setState({
      value: "",
    });
    this.pin.clear();
  };
  onChange = (value) => {
    this.setState({ otp: value });
  };

  async checkIfExists() {
    let payload = {
      mobile: this.state.mobileNumber,
    };
    let response = await this.props.checkSignup(payload);
    if (this.props.signupCheck.USERCHECK.ResponseCode == 100) {
      this.setState({ isUserExist: 2 }); //user not exist
    } else if (this.props.signupCheck.USERCHECK.ResponseCode == 103) {
      this.setState({ isUserExist: 1 });
    }
  }
  async verifyOTP() {
    if (this.state.otp.length < 4) {
      alert("otp should be of 4 digit");
      return false;
    }
    let payload = {
      otp: this.state.otp,
      mobile: this.state.mobileNumber,
    };
    let response = await this.props.createNewUser(payload);
    //console.log(response);
    if (response.ResponseCode == 100) {
      this.loginwithHC();
    } else if (response.ResponseCode == 103) {
      alert("Invalid OTP");
    }
  }
  // async LoginwithPassword(){
  //   let payload={
  //     "mobile": this.state.mobileNumber
  //   }
  //  let response= await this.props.checkSignup(payload)
  //  console.log(this.props.signupCheck.USERCHECK);
  //     if(this.props.signupCheck.USERCHECK.ResponseCode==100){
  //     this.setState({isUserExist:2})  //user not exist
  //     }
  //     else if(this.props.signupCheck.USERCHECK.ResponseCode==103){
  //       this.setState({isUserExist:1})
  //     }
  // }
  async setPassword() {
    let payload = {
      mobile: this.state.mobileNumber,
      name: this.state.Name,
      email: "",
      password: this.state.password,
    };
    let response = await this.props.registration(payload);

    if (response.ResponseCode == 100) {
      //user not exist
      this.setState({ isUserExist: 0, open: false });
      let payloadHC = this.props.signupCheck.USER_DETAILS_HC.Data
        ? this.props.signupCheck.USER_DETAILS_HC.Data[0].CandidateNo
        : "";

      var data1 = {
        candidateId: payloadHC,
        applicantId: this.props.signupCheck.USER_DETAILS_MG.ApplicantId,
      };
      let responseHC = await this.props.setHCIDAction(payloadHC);
      let responseID = await this.props.SaveCandidateId(data1);

      this.forceUpdate();
      //  Session.set("token",response.Authorization.token)
      window.location.reload();
    } else if (this.props.signupCheck.USERCHECK.ResponseCode == 103) {
      this.setState({ isUserExist: 1 });
    } else {
      alert("Something Went Wrong");
    }
  }
  async loginwithPassword() {
    try {
      // this.loginwithHC();
      // return false
      let payload = {
        userId: this.state.mobileNumber,
        password: this.state.password,
      };

      let response = await this.props.login(payload);
      if (response.ResponseCode == 100) {
        let logHC = await this.loginwithHCLogin();
        if (logHC) {
          let payloadHC = this.props.signupCheck.USER_DETAILS_HC.Data
            ? this.props.signupCheck.USER_DETAILS_HC.Data[0].CandidateNo
            : "";
          let responseHC = await this.props.setHCIDAction(payloadHC);
        }
        //user not exist
        this.setState({ isUserExist: 0, open: false });

        this.forceUpdate();
        // Session.set("token",response.Authorization.token)
        window.location.reload();
      } else if (response.ResponseCode == 101) {
        alert("Invalid Password");
      } else {
        alert("Something Went Wrong");
      }
    } catch (error) {
      alert("Something Went Wrong");
    }
  }
  async loginwithHC() {
    try {
      let payload = {
        value: this.state.mobileNumber,
        type: "",
      };

      let response = await this.props.loginHC(payload);
      if (response.ResponseCode == 100) {
        //user not exist
        this.setState({ isUserExist: 4 }); //user  exist

        this.forceUpdate();
        // Session.set("token",response.Authorization.token)
        //window.location.reload();
      } else if (response.ResponseCode == 103) {
        this.setState({ isUserExist: 3 }); //user not exist
      } else {
        alert("Something Went Wrong");
      }
    } catch (error) {
      alert("Something Went Wrong");
    }
  }
  async loginwithHCLogin() {
    try {
      let payload = {
        value: this.state.mobileNumber,
        type: "",
      };

      let response = await this.props.loginHC(payload);
      if (response.ResponseCode == 100) {
        return true;
      } else if (response.ResponseCode == 103) {
        return false;
      } else {
        alert("Something Went Wrong");
        return false;
      }
    } catch (error) {
      alert("Something Went Wrong");
      return false;
    }
  }
  verifyHCDetails() {
    let typedDOB = this.state.dobVerify;
    let typedEmail = this.state.emailVerify;
    let presentDOB = this.props.signupCheck.USER_DETAILS_HC.Data[0].DOB;
    let presentEmail = this.props.signupCheck.USER_DETAILS_HC.Data[0].Email;

    if (
      Date.parse(new Date(presentDOB)) === Date.parse(typedDOB) &&
      typedEmail == presentEmail
    ) {
      this.setState({ isUserExist: 3 });
    } else {
      alert(
        "Details entered doesnot match with existing details please retry or contact support."
      );
    }
    debugger;
  }
  render() {
    return (
      <>
        <div>
          {/* <App forceUpdate={this.state.open}/> */}
          <button
            className={`btn btn1 font-bold ml-4  ${
              this.props.buttonType === "lg"
                ? "component-btncss mr-4"
                : "cust-sign-btn"
            }`}
            onClick={() => this.setState({ open: true })}
          >
            SIGN IN
          </button>

          <Modal
            center
            open={this.state.open}
            onClose={() => this.setState({ open: false })}
            classNames={{
              modal: "loginmodal-w",
            }}
          >
            <div className="login-modal lg:p-4  md:p-4">
              <div>
                <img src={logo} alt="logo" className="mx-auto" />
                {/* <X
              className="cross-login cursor-pointer"
              onClick={() => this.closeModal()}
            /> */}
              </div>

              {/* sign up  */}
              {this.state.isUserExist == 0 ? (
                <form action="" className="">
                  <h2 className="modal-h2">Login / SIGN UP</h2>
                  {/* <div class="form-group modal-form-cs">
              <label for="">Mobile Number</label>
              <input type="text" placeholder="" />
            </div> */}
                  <div className="form-group pt-6 modal-form-cs">
                    <label for="">Mobile Number</label>
                    <input
                      type="text"
                      onChange={(e) =>
                        this.setState({ mobileNumber: e.target.value })
                      }
                      placeholder=""
                    />
                  </div>
                  <div className="form-group pt-6 pb-12 ">
                    <div className="">
                      <label className="custcheckbox">
                        <p className="text-black fsize14  ml-2">
                          You will receive unique code through SMS
                        </p>
                        <input type="checkbox" />
                        <span className="overhide-span"></span>
                      </label>
                      {/* <label class="checkbox-container check-input">
                 You will receive unique code through SMS
                  <input type="checkbox" checked="checked" />
                  <span class="checkmark"></span>
                </label> */}
                    </div>
                  </div>

                  <div className="mt-24">
                    <div className="w-full fixed-btn">
                      <a
                        className="btn btn-orange-otp btn-otp mx-auto myBtn"
                        href="#"
                        onClick={() => this.checkIfExists()}
                      >
                        Submit
                      </a>
                    </div>
                    <p className="fz-16 py-6">
                      Forgot your password ?{" "}
                      <a className="myBtn font-bold" href="#">
                        Reset
                      </a>
                    </p>
                  </div>
                </form>
              ) : (
                ""
              )}
              {/* login in  */}
              {this.state.isUserExist == 1 ? (
                <form action="">
                  <h2 className="modal-h2">LOG IN</h2>

                  <div className="form-group pt-6 modal-form-cs">
                    <label for="">Enter Password</label>
                    <input
                      type="password"
                      onChange={(e) =>
                        this.setState({ password: e.target.value })
                      }
                      placeholder=""
                    />
                  </div>
                  {/* <div className="passowrd-message grid grid-cols-2 gap-6 lg:px-4 md:px-4 mt-6">
                    <div className="flex items-center">
                      <Check className="text189008" width="20" height="20" />
                      <p className="text189008 fsize14 pl-1">
                        Atleast 1 uppercase
                      </p>
                    </div>
                    <div className="flex items-center">
                      <Check className="text189008" width="20" height="20" />
                      <p className="text189008 fsize14 pl-1">
                        Atleast 1 Lowercase
                      </p>
                    </div>

                    <div className="flex items-center">
                      <Check className="text189008" width="20" height="20" />
                      <p className="text189008 fsize14 pl-1">
                        Atleast 1 symbol
                      </p>
                    </div>

                    <div className="flex items-center">
                      <X className="textF43800" width="20" height="20" />
                      <p className="textF43800 fsize14 pl-1">
                        Atleast 1 symbol
                      </p>
                    </div>
                  </div> */}
                  <div className="form-group pt-12  ">
                    <div className="">
                      <label className="custcheckbox">
                        <p className="text-black fsize14  ml-2">
                          Keep me signed in
                        </p>
                        <input
                          type="checkbox"
                          onClick={() =>
                            this.setState({
                              isKeepSignIN: !this.state.isKeepSignIN,
                            })
                          }
                        />
                        <span class="overhide-span"></span>
                      </label>
                      {/* <label class="checkbox-container check-input">
                  Keep me signed in
                  <input type="checkbox" checked="checked" />
                  <span class="checkmark"></span>
                </label> */}
                    </div>
                  </div>

                  <div className="w-full fixed-btn mt-8">
                    <a
                      className="btn btn-orange-otp btn-otp mx-auto myBtn"
                      href="#"
                      onClick={() => this.loginwithPassword()}
                    >
                      Login
                    </a>
                  </div>
                  <p className="fz-16 pt-6 pb-1">
                    Already have an account?{" "}
                    <a className="myBtn font-bold" href="#">
                      Sign In
                    </a>
                  </p>
                  <p className="fz-16 pt-2 pb-6">
                    <a className="myBtn" href="#">
                      Forogot Password?
                    </a>
                  </p>
                </form>
              ) : (
                ""
              )}
              {/*  verify account */}
              {this.state.isUserExist == 2 ? (
                <form action="">
                  <h2 className="modal-h2">SIGN UP</h2>
                  <div className="form-group">
                    <p className="fz-16">
                      Enter the OTP sent to your Mobile
                      <b> {this.state.mobileNumber}</b>
                    </p>
                  </div>
                  <div className="form-group otp-input pinbox-css">
                    <PinInput
                      length={4}
                      focus
                      // disabled
                      ref={(p) => (this.pin = p)}
                      type="numeric"
                      onChange={this.onChange}
                    />
                    {/* <input type="text" onChange={(e)=>this.setState({otp:e.target.value})} placeholder="" />
            <input type="text" onChange={(e)=>this.setState({otp:e.target.value})} placeholder="" />
            <input type="text" onChange={(e)=>this.setState({otp:e.target.value})} placeholder="" />
            <input type="text" onChange={(e)=>this.setState({otp:e.target.value})} placeholder="" /> */}
                  </div>
                  <div class="form-group pt-6 pb-12">
                    <div class="">
                      {/* <label class="checkbox-container">
                  I want to receive updates and important information over
                  <img src={whatsapp} class="inline" alt="" /> Whatsapp
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label> */}
                      <label className="custcheckbox">
                        <div className="flex">
                          <div>
                            <p className="pl-3">
                              I want to receive updates and important
                              information over Keep me signed in{" "}
                            </p>
                            <div className="flex items-center pl-3 pt-1">
                              <img
                                src={whatsapp}
                                class="inline"
                                alt=""
                                className="w-20px h-20px"
                              />{" "}
                              <p className="pl-2">Whatsapp</p>
                            </div>
                          </div>
                        </div>
                        <input
                          type="checkbox"
                          onClick={() =>
                            this.setState({
                              whatsappConsent: !this.state.whatsappConsent,
                            })
                          }
                        />
                        <span class="overhide-span"></span>
                      </label>
                    </div>
                  </div>

                  <div class="w-full fixed-btn mt-8">
                    {this.state.whatsappConsent ? (
                      <a
                        class="btn btn-orange btn-otp mx-auto myBtn"
                        href="#"
                        onClick={(e) => {
                          this.verifyOTP();
                        }}
                      >
                        VERIFY
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </form>
              ) : (
                ""
              )}

              {/*  set password account */}
              {this.state.isUserExist == 3 ? (
                <form action="">
                  <h2 className="modal-h2">SIGN UP</h2>
                  <div class="form-group">
                    <p class="fz-16">Set A strong password</p>
                  </div>
                  <div class="form-group modal-form-cs pt-6">
                    <label for="">Name</label>
                    <input
                      type="text"
                      onChange={(e) => this.setState({ Name: e.target.value })}
                      placeholder=""
                    />
                  </div>
                  <div class="form-group modal-form-cs pt-6">
                    <label for="">Password</label>
                    <input
                      type="password"
                      onChange={(e) =>
                        this.setState({ password: e.target.value })
                      }
                      placeholder=""
                    />
                  </div>
                  <div class="form-group pt-6 modal-form-cs">
                    <label for="">Re-Enter Password</label>
                    <input
                      type="password"
                      onChange={(e) =>
                        this.setState({ Repassword: e.target.value })
                      }
                      placeholder=""
                    />
                  </div>
                  <div className="passowrd-message grid-cols-2 gap-6 px-4 mt-6">
                    <PasswordChecklist
                      rules={[
                        "minLength",
                        "specialChar",
                        "number",
                        "capital",
                        "match",
                      ]}
                      minLength={5}
                      value={this.state.password}
                      valueAgain={this.state.Repassword}
                      onChange={(isValid) => {
                        this.setState({ isValid: isValid });
                      }}
                    />
                  </div>
                  {/* <div className="passowrd-message grid grid-cols-2 gap-6 px-4 mt-6">
                    <div className="flex items-center">
                      <Check className="text189008" width="20" height="20" />
                      <p className="text189008 fsize14 pl-1">
                        Atleast 1 uppercase
                      </p>
                    </div>
                    <div className="flex items-center">
                      <Check className="text189008" width="20" height="20" />
                      <p className="text189008 fsize14 pl-1">
                        Atleast 1 Lowercase
                      </p>
                    </div>

                    <div className="flex items-center">
                      <Check className="text189008" width="20" height="20" />
                      <p className="text189008 fsize14 pl-1">
                        Atleast 1 symbol
                      </p>
                    </div>

                    <div className="flex items-center">
                      <X className="textF43800" width="20" height="20" />
                      <p className="textF43800 fsize14 pl-1">
                        Atleast 1 symbol
                      </p>
                    </div>
                  </div>
             */}
                  <div class="form-group pt-10 pb-12">
                    <div class="">
                      <label class="custcheckbox">
                        <p className="pl-2">
                          I accept the end-user license agreement & terms &
                          conditions.
                        </p>

                        <input
                          type="checkbox"
                          onClick={() =>
                            this.setState({
                              termsCondition: !this.state.termsCondition,
                            })
                          }
                        />
                        <span class="overhide-span"></span>
                      </label>
                      {/* <label class="checkbox-container">
                I accept the end-user license agreement & terms & conditions.
                  <input type="checkbox" checked="checked" />
                  <span class="checkmark"></span>
                </label> */}
                    </div>
                  </div>
                  <div class="w-full fixed-btn">
                    {this.state.termsCondition && this.state.isValid ? (
                      <a
                        class="btn btn-orange btn-otp mx-auto myBtn"
                        href="#"
                        onClick={() => this.setPassword()}
                      >
                        Submit
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </form>
              ) : (
                ""
              )}

              {/*  set password account */}
              {this.state.isUserExist == 4 ? (
                <form action="">
                  <h2 className="modal-h2">SIGN UP</h2>
                  <div class="form-group mb-8 mt-4">
                    <p class="fz-16 text-black">
                      We see you have previously logged in to ICICI Careers.
                      Kindly enter the details below.
                    </p>
                  </div>
                  <div class="form-group modal-form-cs">
                    <label for="">Date of birth</label>
                    <div className="datepickerw-full">
                      <DatePicker
                        selected={this.state.dobVerify}
                        dateFormat="dd/MM/yyyy"
                        className="w-full"
                        onChange={(date) => this.setState({ dobVerify: date })}
                      />
                    </div>

                    {/* <input type="date" onChange={(e)=>this.setState({dobVerify:e.target.value})} placeholder="" /> */}
                  </div>
                  <div class="form-group pt-4 modal-form-cs">
                    <label for="">Email</label>
                    <input
                      type="text"
                      onChange={(e) =>
                        this.setState({ emailVerify: e.target.value })
                      }
                      placeholder=""
                    />
                  </div>

                  <div class="w-full fixed-btn mt-16">
                    <a
                      class="btn btn-orange btn-otp mx-auto myBtn"
                      href="#"
                      onClick={() => this.verifyHCDetails()}
                    >
                      PROCEED
                    </a>
                  </div>
                </form>
              ) : (
                ""
              )}
              {/* FORGOT PASSWORD */}

              <form action="" className="hidden">
                <h2 className="modal-h2">FORGOT PASSWORD</h2>
                <div class="form-group modal-form-cs">
                  <label for="">Mobile Number</label>
                  <input type="text" placeholder="" />
                </div>
                <div class="form-group pt-6 modal-form-cs mb-14">
                  <label for="">Email</label>
                  <input type="email" placeholder="" />
                </div>

                <div class="w-full fixed-btn">
                  <a class="btn btn-orange-otp btn-otp mx-auto myBtn" href="#">
                    GET OTP
                  </a>
                </div>
              </form>
            </div>
          </Modal>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    signupCheck: state.Auth.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    checkSignup: async (payload) => await dispatch(checkSignup(payload)),
    login: async (payload) => await dispatch(login(payload)),
    createNewUser: async (payload) => await dispatch(createNewUser(payload)),
    registration: async (payload) => await dispatch(registration(payload)),
    loginHC: async (payload) => await dispatch(loginHC(payload)),
    setHCIDAction: async (payload) => await dispatch(setHCIDAction(payload)),
    SaveCandidateId: async (payload) =>
      await dispatch(SaveCandidateId(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
